// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"fef785c5","633":"ceedd6bc"}[chunkId] + ".chunk.js";
};